var jade = require("/opt/codecombat/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (Date, _, state, undefined, view) {
buf.push("<form class=\"modal-body segment-check\"><div class=\"modal-body-content\">");
switch (view.signupState.get('path')){
case 'student':
buf.push("<span data-i18n=\"signup.enter_class_code\"></span><div class=\"class-code-input-group form-group\"><input name=\"classCode\"" + (jade.attr("value", view.signupState.get('classCode'), true, true)) + " class=\"class-code-input\"><div class=\"render\">");
if (!( _.isEmpty(view.signupState.get('classCode'))))
{
if ( state.get('classCodeValid'))
{
buf.push("<span class=\"glyphicon glyphicon-ok-circle class-code-valid-icon\"></span>");
}
else
{
buf.push("<span class=\"glyphicon glyphicon-remove-circle class-code-valid-icon\"></span>");
}
}
buf.push("</div></div><p class=\"render\">");
if ( _.isEmpty(view.signupState.get('classCode')))
{
buf.push("<span data-i18n=\"signup.ask_teacher_1\"></span>");
}
else if ( state.get('classCodeValid'))
{
buf.push("<span data-i18n=\"signup.about_to_join\" class=\"small\"></span><br><span class=\"classroom-name\">" + (jade.escape(null == (jade_interp = view.classroom.get('name')) ? "" : jade_interp)) + "</span><br>");
if ( view.classroom.owner.get('firstName'))
{
buf.push("<span class=\"teacher-name\">" + (jade.escape(null == (jade_interp = view.classroom.owner.get('firstName') + " " + view.classroom.owner.get('lastName')) ? "" : jade_interp)) + "</span>");
}
else if ( view.classroom.owner.get('name'))
{
buf.push("<span class=\"teacher-name\">" + (jade.escape(null == (jade_interp = view.classroom.owner.get('name')) ? "" : jade_interp)) + "</span>");
}
}
else
{
buf.push("<span data-i18n=\"signup.classroom_not_found\"></span>");
}
if ( _.isEmpty(view.signupState.get('classCode')) || !state.get('classCodeValid'))
{
buf.push("<br><span data-i18n=\"signup.ask_teacher_2\" class=\"spr\"></span><a class=\"individual-path-button\"><span data-i18n=\"signup.ask_teacher_3\"></span></a><span data-i18n=\"signup.ask_teacher_4\" class=\"spl\"></span>");
}
buf.push("</p>");
  break;
case 'teacher':
buf.push("<!-- TODO-->");
  break;
case 'individual':
if ( view.signupState.get('subModalContinue'))
{
buf.push("<span data-i18n=\"signup.sign_in_to_continue\"></span><br>");
}
buf.push("<div class=\"birthday-form-group form-group\"><span data-i18n=\"signup.enter_birthdate\"></span><div class=\"input-border\"><select id=\"birthday-month-input\" name=\"birthdayMonth\" style=\"width: 106px; float: left\" class=\"input-large form-control\"><option value=\"\" data-i18n=\"calendar.month\"></option>");
// iterate ['january','february','march','april','may','june','july','august','september','october','november','december']
;(function(){
  var $$obj = ['january','february','march','april','may','june','july','august','september','october','november','december'];
  if ('number' == typeof $$obj.length) {

    for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
      var name = $$obj[index];

var month = index + 1
buf.push("<option" + (jade.attr("data-i18n", "calendar." + (name) + "", true, true)) + (jade.attr("value", month, true, true)) + (jade.attr("selected", (month == view.signupState.get('birthdayMonth')), true, true)) + "></option>");
    }

  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;      var name = $$obj[index];

var month = index + 1
buf.push("<option" + (jade.attr("data-i18n", "calendar." + (name) + "", true, true)) + (jade.attr("value", month, true, true)) + (jade.attr("selected", (month == view.signupState.get('birthdayMonth')), true, true)) + "></option>");
    }

  }
}).call(this);

buf.push("</select><select id=\"birthday-day-input\" name=\"birthdayDay\" style=\"width: 75px; float: left\" class=\"input-large form-control\"><option value=\"\" data-i18n=\"calendar.day\"></option>");
// iterate _.range(1,32)
;(function(){
  var $$obj = _.range(1,32);
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var day = $$obj[$index];

buf.push("<option" + (jade.attr("selected", (day == view.signupState.get('birthdayDay')), true, true)) + ">" + (jade.escape((jade_interp = day) == null ? '' : jade_interp)) + "</option>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var day = $$obj[$index];

buf.push("<option" + (jade.attr("selected", (day == view.signupState.get('birthdayDay')), true, true)) + ">" + (jade.escape((jade_interp = day) == null ? '' : jade_interp)) + "</option>");
    }

  }
}).call(this);

buf.push("</select><select id=\"birthday-year-input\" name=\"birthdayYear\" style=\"width: 90px; float: left\" class=\"input-large form-control\"><option value=\"\" data-i18n=\"calendar.year\"></option>");
var thisYear = new Date().getFullYear()
// iterate _.range(thisYear, thisYear - 100, -1)
;(function(){
  var $$obj = _.range(thisYear, thisYear - 100, -1);
  if ('number' == typeof $$obj.length) {

    for (var $index = 0, $$l = $$obj.length; $index < $$l; $index++) {
      var year = $$obj[$index];

buf.push("<option" + (jade.attr("selected", (year == view.signupState.get('birthdayYear')), true, true)) + ">" + (jade.escape((jade_interp = year) == null ? '' : jade_interp)) + "</option>");
    }

  } else {
    var $$l = 0;
    for (var $index in $$obj) {
      $$l++;      var year = $$obj[$index];

buf.push("<option" + (jade.attr("selected", (year == view.signupState.get('birthdayYear')), true, true)) + ">" + (jade.escape((jade_interp = year) == null ? '' : jade_interp)) + "</option>");
    }

  }
}).call(this);

buf.push("</select></div></div><div data-i18n=\"signup.parent_use_birthdate\" class=\"parent_birthdate\"></div>");
  break;
default:
buf.push("<p><span>Sign-up error, please contact </span>" + (jade.escape(null == (jade_interp = " ") ? "" : jade_interp)) + "<a href=\"mailto:support@codecombat.com\">support@codecombat.com</a>.</p>");
  break;
}
buf.push("</div><!-- In reverse order for tabbing purposes--><div class=\"history-nav-buttons\"><button type=\"submit\" class=\"next-button btn btn-lg btn-navy\"><span data-i18n=\"common.continue\"></span></button>");
if ( !view.signupState.get('subModalContinue'))
{
buf.push("<button type=\"button\" class=\"back-to-account-type btn btn-lg btn-navy-alt\"><span data-i18n=\"common.back\"></span></button>");
}
buf.push("</div></form>");}.call(this,"Date" in locals_for_with?locals_for_with.Date:typeof Date!=="undefined"?Date:undefined,"_" in locals_for_with?locals_for_with._:typeof _!=="undefined"?_:undefined,"state" in locals_for_with?locals_for_with.state:typeof state!=="undefined"?state:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined,"view" in locals_for_with?locals_for_with.view:typeof view!=="undefined"?view:undefined));;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./app/templates/core/create-account-modal/segment-check-view.jade
// module id = 815
// module chunks = 0 9 12 13 15 16 79 80 81 82 83 84 85 86 87 88 89 90 91